import styled from "styled-components";
import { IconContext } from "react-icons";
import { IoMdPlay } from "react-icons/io";
import { MdRestore } from "react-icons/md";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
`;

const Button = styled.button`
  border: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;
  background: transparent;
  color: inherit;
  font: inherit;
  line-height: normal;
  appearance: none;
  outline: none;
  text-align: inherit;
  cursor: pointer;
`;

const Controls = ({ controlTimer, resetTimer }) => {
  return (
    <Wrapper>
      <IconContext.Provider value={{ size: "2em" }}>
        <Button>
          <IoMdPlay onClick={controlTimer} />
        </Button>
        <Button>
          <MdRestore onClick={resetTimer} />
        </Button>
      </IconContext.Provider>
    </Wrapper>
  );
};

export default Controls;